<template>
  <div>
    <div>
      <card class="card" title="Certificates">
        <div class="card__right-button">
          <div v-if="canManageQuestions()" class="position-relative">
            <button
              class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn"
              @click="openNewCertificateModal = true"
            >
              <i class="fas fa-plus"></i>
            </button>
            <div class="tooltipCustom tooltipCustom--bottom">Create new Certificate</div>
          </div>
        </div>
        <div>
          <div v-if="certificates && !loadingCertificates" class="certificates">
            <div class="row" v-if="certificates.length > 0">
              <div
                v-for="(certificate, index) in certificates"
                v-bind:key="index"
                class="certificate certificate--show cursor-pointer"
              >
                <div @click="openEditCertificate(certificate, index)">
                  <img class="certificate__img" :src="certificate.img_url" alt="" />
                  <div class="certificate__text-block">
                    <p class="certificate__name">{{ certificate.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>This company does not have certificates</div>
          </div>
          <div v-if="loadingCertificates" class="loading certificate__loading">
            <MoonLoader />
          </div>
        </div>
      </card>
    </div>
    <ModalTemplate
      component-name="CreateCertificateModal"
      name="CreateCertificateModal"
      :data="{
        header: 'Create new External Certificate',
      }"
      :clicked="openNewCertificateModal"
      @update:field="openNewCertificateModal = false"
      @submit="addCertificate($event)"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="EditCertificateModal"
      name="EditCertificateModal"
      :data="{
        header: 'Edit Certificate',
        certificate: selected_certificate,
      }"
      :clicked="openEditCertificateModal"
      @update:field="openEditCertificateModal = false"
      @submit="updateCertificate($event)"
      @deleted="openDeleteModal()"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="DeleteModal"
      button-component-name="DeleteButton"
      name="DeleteModal"
      action="deleteCertificate"
      :clicked="openDelete"
      :data="{
        deletion_object_name: selected_certificate_name,
        deletion_object_text: 'this certificate',
        delete_button_title: 'Delete Certificate',
        header: 'Delete Certificate',
      }"
      :button_data="{
        title: 'Delete Certificate',
      }"
      @submit="deleteCertificate()"
      @update:field="openDelete = false"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import MoonLoader from '../../components/svg/SvgLoaderMoon';
import CompanyCertificatesController from '../../controllers/CompanyCertificates/CompanyCertificatesController';
import CertificateController from '../../controllers/Certificates/CertificateController';
import ModalTemplate from '../../components/modals/ModalTemplate';
import checkIfCanUpdateQuestions from '@/router/scopes/manage_questions/CheckIfCanUpdateQuestions';
export default {
  name: 'ManageCertificates',
  components: { ModalTemplate, MoonLoader },
  data() {
    return {
      loadingCertificates: false,
      certificates: null,
      openNewCertificateModal: false,
      openEditCertificateModal: false,
      selected_certificate: null,
      selected_certificate_name: null,
      selected_index: null,
      openDelete: false,
    };
  },
  async beforeMount() {
    this.setLoading();
    await this.setCertificates();
    this.resetLoading();
  },
  methods: {
    async setCertificates() {
      this.certificates = await CertificateController.index();
    },
    setLoading() {
      this.loadingCertificates = true;
    },
    resetLoading() {
      this.loadingCertificates = false;
    },
    async addCertificate(certificate) {
      this.certificates.push(certificate);
    },
    openEditCertificate(certificate, index) {
      if (this.canManageQuestions()) {
        this.selected_certificate = certificate;
        this.selected_certificate_name = certificate.name;
        this.selected_index = index;
        this.openEditCertificateModal = true;
      }
    },
    updateCertificate(certificate) {
      this.certificates[this.selected_index] = certificate;
    },
    removeCertificate(certificate) {
      this.certificates.splice(this.selected_index, 1);
    },
    async deleteCertificate() {
      try {
        await CertificateController.destroy(this.selected_certificate.id);
        this.$emit('deleted', this.selected_certificate);
        this.$notify({
          type: 'success',
          title: 'Certificate was deleted',
        });
        this.removeCertificate(this.selected_certificate);
      } catch (e) {
        Object.entries(e.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
    openDeleteModal() {
      this.openDelete = true;
    },
    canManageQuestions() {
      return checkIfCanUpdateQuestions();
    },
  },
};
</script>

<style scoped></style>
